import axios from "axios";
// https://ibile.paycentreafrica.com:53525
// https://bugfix.paypad.com.ng
export const baseUrl = `https://ibile.paycentreafrica.com:53525`;

const http = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "X-AUTH": localStorage.getItem("X-PC-ACCESS") ?? "",
  },
});

http.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (request) => {
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;
